<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <router-link
        class="btn btn-icon btn-sm btn-clean"
        :to="{
          name: 'admin.crm.customers.edit',
          params: { id: item.id },
        }"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </router-link>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.name="{ item }">
      <router-link
        :to="{
          name: 'admin.crm.customers.edit',
          params: { id: item.id },
        }"
      >
        {{ item.name }}
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.is_active="{ item }">
      <rs-table-cell-boolean :value="item.is_active" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.email="{ value }">
      <rs-table-cell-email :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.product_name="{ item, value }">
      <router-link
        v-if="item.product_id"
        :to="{
          name: 'admin.products.edit',
          params: { id: item.product_id },
        }"
      >
        {{ value }}
      </router-link>
      <em v-else>Yok</em>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.product_starts_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.product_ends_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.active_product_count="{ value }">
      <strong v-if="value === 0" class="text-danger">0</strong>
      <template v-else>{{ value }}</template>
    </template>
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";

export default {
  name: "AdminCustomerListComponent",
  mixins: [hasDataTable],
  props: {
    customerGroupId: {
      type: Number,
      required: false,
    },
  },
  watch: {
    customerGroupId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {
        sortBy: ["name"],
        sortDesc: [false],
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "Adı",
          value: "name",
          searchable: "text",
          width: "200px",
        },
        {
          text: "Ürün",
          value: "product_name",
          searchable: "text",
        },
        {
          text: "Ürün Başlangıç",
          value: "product_starts_on",
          searchable: "date",
        },
        {
          text: "Ürün Bitiş",
          value: "product_ends_on",
          searchable: "date",
        },
        {
          text: "Aktif Ürün Sayısı",
          value: "active_product_count",
          searchable: "number",
          align: "end",
        },
        {
          text: "Unvan",
          value: "title",
          searchable: "text",
          width: "300px",
        },
        {
          text: "E-posta",
          value: "email",
          searchable: "text",
        },
        {
          text: "VKN/TCKN",
          value: "tax_number",
          searchable: "text",
        },
        {
          text: "TYA",
          value: "cluster_count",
          searchable: "number",
          notPrice: true,
          align: "end",
        },
        {
          text: "Durum",
          value: "is_active",
          searchable: "isActive",
          align: "center",
        },
        {
          text: "Yetkili Kişi",
          value: "authorized_user_name",
          searchable: "text",
        },
        {
          text: "Adres",
          value: "address",
          searchable: "text",
          width: "400px",
        },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.customerGroupId) {
        params.customer_group_id = this.customerGroupId;
      }

      return this.$api
        .query("api-super-admin/customers", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
